<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9664_98597)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.0156 2.01172C14.6259 2.01172 17.0026 3.01184 18.7834 4.64979L15.9932 7.41081C14.9311 6.50662 13.5545 5.96094 12.0504 5.96094C8.68943 5.96094 5.96484 8.68552 5.96484 12.0465C5.96484 15.4074 8.68943 18.132 12.0504 18.132C14.7596 18.132 17.0553 16.3616 17.8438 13.9147H12.2734V10.2305H17.8603C17.8603 10.2304 17.8603 10.2303 17.8603 10.2303H21.8574C21.9614 10.8084 22.0156 11.4037 22.0156 12.0117C22.0156 17.5346 17.5385 22.0117 12.0156 22.0117C6.49278 22.0117 2.01562 17.5346 2.01562 12.0117C2.01562 6.48887 6.49278 2.01172 12.0156 2.01172Z"
        fill="#34A84A"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.5313 19.5763C20.6578 17.7424 22.0039 15.0285 22.0039 12.0002C22.0039 11.3936 21.9499 10.7995 21.8464 10.2227H17.8498L17.8498 10.2229H12.2656V13.9071H17.8308C17.3925 15.264 16.4907 16.4125 15.312 17.1661L18.5313 19.5763Z"
        fill="#4280F6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.7756 4.64979C16.9948 3.01184 14.6181 2.01172 12.0078 2.01172C8.09048 2.01172 4.69925 4.26415 3.05859 7.54452L6.30199 10.0216C7.13636 7.6561 9.39148 5.96094 12.0425 5.96094C13.5466 5.96094 14.9233 6.50662 15.9853 7.41081L18.7756 4.64979Z"
        fill="#EB3C35"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.01562 12.016C2.01562 10.3988 2.39952 8.87126 3.08115 7.51953L6.32241 9.9906C6.09097 10.634 5.96484 11.3277 5.96484 12.0508C5.96484 12.738 6.07875 13.3986 6.28872 14.0147L3.09154 16.5331C2.40342 15.1763 2.01562 13.6414 2.01562 12.016Z"
        fill="#FDBD05"
      />
      <rect
        x="13.5"
        y="13.5"
        width="10.5"
        height="10.5"
        rx="5.25"
        fill="#4A24AC"
      />
      <path
        d="M19.5 15.75L21.75 18.7441M21.75 18.7441H15.75M21.75 18.7441L19.5 21.75"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9664_98597">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "RbToGoogleIcon"
};
</script>
